<form #translationForm="ngForm" id="translationFieldEditor" name="editTranslation">
  <div class="row" style="margin-bottom: 25px;">
    <div class="col-md-6" *ngFor="let locale of Locales">
      <mat-form-field>
        <mat-label>{{placeholder ? placeholder + ' - ' + locale.getFullLocale() : locale.getFullLocale()}}</mat-label>
        <input matInput name="Translation" [ngModel]="getTranslation(locale)" #ngGroup="ngModelGroup"
               (ngModelChange)="setTranslation(locale, $event)" [ngModelGroup]="locale.getFullLocale()">
        <mat-icon matIconSuffix [matTooltip]="locale.Id">translate</mat-icon>
      </mat-form-field>
    </div>
  </div>
</form>
